export default __webpack_public_path__ + "static/media/cli-niplan.25be147e.jpg";